import { ReactElement, useState, useRef, useEffect } from 'react';
import ReactGA from 'react-ga';
import classnames from 'classnames';

import DownArrow from '../../images/downArrow.svg';

import styles from './Accordion.module.scss';

interface iProps {
  title: string;
  popupContent: string | ReactElement;
  alwaysOpen?: boolean;
  openByDefault?: boolean;
  variant?: 'wdp' | 'default';
  openAccordionOnClick?: boolean;
}

const Accordion = ({ title, popupContent, alwaysOpen = false, openByDefault = false, variant = 'default', openAccordionOnClick = false }: iProps): ReactElement => {
  const [accordionOpen, setAccordionOpen] = useState(openByDefault || alwaysOpen);
  const spanRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number>();
  const rendercontent = (): ReactElement => {
    if (typeof popupContent === 'string') {
      return <div className={styles.accordContent} dangerouslySetInnerHTML={{ __html: popupContent }} />;
    }
    return <>{popupContent}</>;
  };

  const updateHeight = () => {
    if (accordionOpen && spanRef.current) {
      const newHeight = spanRef.current.scrollHeight;
      setHeight(newHeight);
    } else {
      setHeight(0);
    }
  };
  useEffect(() => {
    updateHeight();
  }, [accordionOpen, popupContent]);

  const handleExpending = () => {
    setAccordionOpen((prev) => {
      const next = !prev;
      if (next) {
        ReactGA.event({
          category: 'Accordion',
          action: 'expand',
          label: title,
        });
      }
      return next;
    });
  };
  useEffect(() => {
    if (openAccordionOnClick) setAccordionOpen(true);
    else setAccordionOpen(false);
  }, [openAccordionOnClick]);
  const iconStyle = !accordionOpen ? styles.iconInitiated : styles.iconClicked;
  return (
    <>
      <button className={styles.accordionHeader} type="button" onClick={handleExpending}>
        <div
          className={classnames(styles.accordionTitle, {
            [styles.wdpTitle]: variant === 'wdp',
          })}>
          <span>{title}</span>
        </div>
        {alwaysOpen
        ? (
          <div className={styles.iconDiv}>
            <img src={DownArrow} className={styles.arrowIcon} alt="arrow" />
          </div>
        ) : (
          <div className={styles.iconDiv}>
            <img
              src={DownArrow}
              className={`${iconStyle} ${styles.arrowIcon}`}
              alt="Expand/Contract the quesiton" />
          </div>
        )}
      </button>
      <div className={styles.accordionContent} style={{ height }}>
        <div ref={spanRef} className={variant === 'default' ? styles.divPadding : ''}>
          {rendercontent()}
        </div>
      </div>
    </>
  );
};

export default Accordion;
